/**
 * popupVideo 
 * Function for modal video popup
 */
(($, Drupal, once) => {
    Drupal.behaviors.popupVideo = {
      attach() {
        once(
          "popupVideo",
          "div.field--name-field-media-oembed-video"
        ).forEach((element) => {
          // Get the modal
          var modal = document.getElementById("myModal");

          // Get the <span> element that closes the modal
          var span = document.getElementsByClassName("modal-video__close")[0];

          // When the user clicks on <span> (x), close the modal
          span.onclick = function() {
            modal.style.display = "none";
            $("#myModal" + ' iframe').attr('src', '');
          }

          window.onclick = function(event) {
            if (event.target == modal) {
              modal.style.display = "none";
              $("#myModal" + ' iframe').attr('src', '');
            }
          }
          
          $(element).click(function(e) {
            e.preventDefault();
            // Get the modal
            modal.style.display = "block";

            var videoSRC = $(this)[0].children[0].src;
            let text = videoSRC;
            const myArray = text.split("/media/");
            var videoSRCauto = '/media/' + myArray[1];
            $("#myModal" + ' iframe').attr('src', videoSRCauto);
          });
        });
      },
    };
  })(jQuery, Drupal, once);
  